import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Box from 'ui-box';
import {
  Card,
  Heading,
  Grid,
  Container,
  majorScale,
  PageContainer,
} from '../../npaper';

const SettingLink = ({ to, title }: { to: string; title: string }) => (
  <Box
    is={Link}
    to={to}
    className="link"
    display="block"
    marginTop={majorScale(1)}
  >
    {title}
  </Box>
);

export const Settings = () => {
  return (
    <PageContainer>
      <Container>
        <Heading size={700}>
          <FormattedMessage defaultMessage="Settings" />
        </Heading>

        <Grid marginTop={majorScale(4)}>
          <Card className="col-span-4" padding={majorScale(3)}>
            <Heading size={400} marginBottom={majorScale(2)}>
              <FormattedMessage defaultMessage="Account" />
            </Heading>

            <SettingLink title="Konto detaljer" to="/settings/account" />
            <SettingLink title="Brugere og rettigheder" to="/settings/users" />
            <SettingLink title="Abonnement" to="/settings/subscription" />
            <SettingLink title="Lagerstyring" to="/settings/warehousing" />
            <SettingLink title="Integrationer" to="/settings/integrations" />
            {/*<SettingLink title="API adgang" to="/settings/api" />*/}
          </Card>

          <Card className="col-span-4" padding={majorScale(3)}>
            <Heading size={400} marginBottom={majorScale(2)}>
              <FormattedMessage defaultMessage="Invoicing" />
            </Heading>

            <SettingLink title="Bankoplysninger" to="/settings/bank-details" />
            <SettingLink title="Fakturanumrer" to="/settings/invoicing" />
            <SettingLink title="Momskoder" to="/settings/vat-rates" />
            <SettingLink
              title="Salgs- og leveringsbetingelser"
              to="/settings/terms"
            />
            <SettingLink title="Skabeloner" to="/settings/templates" />
          </Card>
          <Card className="col-span-4" padding={majorScale(3)}>
            <Heading size={400} marginBottom={majorScale(2)}>
              <FormattedMessage defaultMessage="My profile" />
            </Heading>

            <SettingLink title="Profil" to="/settings/profile" />
            <SettingLink title="Vælg organisation" to="/auth/organisations" />
          </Card>
        </Grid>
      </Container>
    </PageContainer>
  );
};
